import { QRCodeSVG } from 'qrcode.react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Copy, Download } from 'lucide-react';
import { mediaUrl, formatMoney } from '@/lib/api';
import { toast } from 'sonner';
import { useShareConfig } from '@/context/ShareConfigContext';

export const AdQRShareModal = ({ open, onOpenChange, ad }) => {
    const { buildShareUrl } = useShareConfig();
    if (!ad) return null;
    const url = buildShareUrl(`/a/${ad.id}`);
    const primaryImage = ad.media?.find(m => m.kind === 'image');

    const copyLink = async () => {
        try { await navigator.clipboard.writeText(url); toast.success('Enlace copiado'); } catch { toast.error('No se pudo copiar'); }
    };

    const downloadQR = () => {
        const svg = document.getElementById('ad-share-qr-svg');
        if (!svg) return;
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.onload = () => {
            canvas.width = 512; canvas.height = 512;
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            const link = document.createElement('a');
            link.download = `${ad.id}-qr.png`;
            link.href = canvas.toDataURL('image/png');
            link.click();
        };
        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                className="w-[calc(100vw-2rem)] sm:max-w-md max-h-[90vh] overflow-y-auto p-4 sm:p-6"
                data-testid="ad-qr-share-modal"
            >
                <DialogHeader>
                    <DialogTitle>Compartir con QR</DialogTitle>
                </DialogHeader>
                <div className="space-y-3 sm:space-y-4">
                    {primaryImage && (
                        <div className="aspect-[16/10] rounded-xl overflow-hidden bg-neutral-100">
                            <img src={mediaUrl(primaryImage.url)} alt={ad.title} className="w-full h-full object-cover" />
                        </div>
                    )}
                    <div className="text-center px-1">
                        <div className="font-semibold text-sm sm:text-base line-clamp-2">{ad.title}</div>
                        <div className="money text-xl sm:text-2xl mt-1 text-red-600">{formatMoney(ad.price, ad.currency)}</div>
                    </div>
                    <div className="flex justify-center py-2">
                        <div className="p-3 sm:p-4 bg-white rounded-2xl border-2 border-red-600">
                            <QRCodeSVG
                                id="ad-share-qr-svg"
                                value={url}
                                size={typeof window !== 'undefined' && window.innerWidth < 480 ? 160 : 220}
                                level="M"
                                includeMargin={false}
                                fgColor="#dc2626"
                            />
                        </div>
                    </div>
                    <p className="text-[11px] sm:text-xs text-center text-muted-foreground break-all px-2">{url}</p>
                    <div className="grid grid-cols-2 gap-2">
                        <Button variant="outline" size="sm" onClick={copyLink} data-testid="qr-copy-btn" className="text-xs sm:text-sm"><Copy className="h-4 w-4 mr-1 sm:mr-2" />Copiar enlace</Button>
                        <Button size="sm" onClick={downloadQR} data-testid="qr-download-btn" className="text-xs sm:text-sm"><Download className="h-4 w-4 mr-1 sm:mr-2" />Descargar QR</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
